import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
    Box
} from '@mui/material';
import { useAuth } from './AuthContext';

const SessionWarningDialog = () => {
    const { sessionWarning, sessionTimeRemaining, extendSession, logout } = useAuth();

    const handleExtendSession = () => {
        extendSession();
    };

    const handleLogout = () => {
        logout();
    };

    return (
        <Dialog
            open={sessionWarning}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Session About to Expire
                </Alert>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Your session will expire in {sessionTimeRemaining || 0} minute{sessionTimeRemaining !== 1 ? 's' : ''}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Click "Stay Logged In" to extend your session, or "Logout" to end your session now.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button 
                    onClick={handleLogout} 
                    color="error" 
                    variant="outlined"
                    sx={{ minWidth: 120 }}
                >
                    Logout
                </Button>
                <Button 
                    onClick={handleExtendSession} 
                    color="primary" 
                    variant="contained"
                    sx={{ minWidth: 120 }}
                >
                    Stay Logged In
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionWarningDialog;
